import { breakpoints, useTheme } from "@rally/ui-kit";
import { useEffect, useRef } from "react";
import { detailsCard } from "./details.tsx";
import { Panels } from "./panels.tsx";
import { showDetails, showsHere, useShowing } from "./showing.ts";
import { drawnFor, onlyOne, type Stack } from "./stacking.ts";

export function Beside({ conversation, me, stack }: { conversation: string; me: string; stack: Stack }) {
  const theme = useTheme();
  const narrow = theme.isAtMost(breakpoints.phone);

  const showing = showsHere(useShowing(), narrow);

  useEffect(() => {
    if (!narrow || !showing) return;
    const path = window.location.pathname;
    window.history.pushState({ rallyDetails: true }, "", path);
    const back = () => showDetails(false);
    window.addEventListener("popstate", back);
    return () => {
      window.removeEventListener("popstate", back);
      if (window.history.state?.rallyDetails) window.history.back();
    };
  }, [narrow, showing]);

  const open = onlyOne(drawnFor(stack, conversation));

  const standing = showing ? detailsCard(conversation, me) : null;

  const wasIn = useRef(conversation);
  const changed = wasIn.current !== conversation;
  wasIn.current = conversation;

  return <Panels standing={standing} open={open} abrupt={changed} />;
}
